module.exports = __webpack_public_path__ + "swiss.svg?2cc9f726d37133fe709d2c1f39b3e6f5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/swiss.svg
// module id = 142
// module chunks = 0